// extracted by mini-css-extract-plugin
module.exports = {"userInfo":"UserInfo-module--userInfo--3oTsb","avatar":"UserInfo-module--avatar--3fKPl","content":"UserInfo-module--content--1Vg72"};